import localStorage from "./localStorage"
// import xhr from "./xhr"

export default {
    authGuard: async function(roles = ["USER"]) {
        try {
            if(!Array.isArray(roles)) roles = [roles]
            let user = localStorage.get('session');
            if(!user) return false;
            if(!roles.includes(user.role)) return false
            // await xhr('GET', '/api/users/self/profile', {}, true, false);
            return true;
        } catch (error) {
            console.error("Error in auth guard >>>", error)
            return false;
        }
    }
}